export default __webpack_public_path__ + "static/media/CreateButton.bdb5be11.svg";